import {
  FilterParamsConfig,
  FilterParamTypes,
} from 'SRC/hooks/searchParams/types';

export function editParams(
  params:
    | Record<string, string[]>
    | Record<string, string>
    | Partial<Record<string, string | string[] | null | undefined>>,
  paramsCopy: URLSearchParams,
  config: FilterParamsConfig | FilterParamTypes,
) {
  Object.entries<string | string[] | undefined | null>(params).forEach(
    ([key, values]) => {
      const type = typeof config === 'string' ? config : config[key];

      if (type === 'string') {
        values === undefined
          ? paramsCopy.delete(key)
          : paramsCopy.set(key, (values as string) ?? '');
      }

      if (type === 'array') {
        paramsCopy.delete(key);
        values === null
          ? paramsCopy.set(key, values ?? '')
          : values !== undefined &&
            (values as string[]).forEach((value) =>
              paramsCopy.append(key, value),
            );
      }
    },
  );
}
